import { pathsSchema } from "shell/api/config";

export const sandboxStandalonePaths = {
  index: "/",
  login: "/login",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyEmail: "/verify-email",
  explorer: "/explorer",
  credentials: "/credentials",
  recipes: "/recipes",
  recipeDetail: "/recipes/:recipeId",
  terms: "/terms",
};

export const sandboxPaths =
  import.meta.env.VITE_BUILD_TARGET === "sandbox"
    ? sandboxStandalonePaths
    : pathsSchema.sandbox;
